import React, { Component } from 'react';
import axios from 'axios';

import { GetBaseUrl } from '@/utils/ConfigHelper'
import Card from './Card/Card';
import DesignSelectPopup from '../../DesignSelect/DesignSelectPopup/DesignSelectPopup';
import { Pagination } from '../Common/Pagination/Pagination';
import Loading from '@/Common/loading/loading'
import EmptyVideo from '../../UserPage/MyVideo/emptyVideo/emptyVideo';
import { _getTemplateById } from "../../Home";
import i18n from "../../i18n";
import './index.scss';

import TemplateHelper from "@/utils/TemplateHelper"

import { connect } from 'react-redux'

class LikedVideoClass extends Component {
  state = {
    isDialogOpened: false,
    selectedVideoId: null,
    currentPage: 0,
    cardsPerPage: 14,
    mobile: false,
    likedTemplates: undefined,
    templates: []
  };

  templateGroupMap = {}

  async componentDidMount() {
    if (!this.props.isMounted) return

    const token = localStorage.getItem('token');

    const response = await axios.get(
      `${GetBaseUrl()}/api/user/like-template-datas`,
      {
          headers: { Authorization: `Bearer ${token}` }
      }
    )

    if (response && response.data) {
      const dataArr = response.data
      if (Array.isArray(dataArr)) {
        dataArr.forEach(item => {
          this.templateGroupMap[item.name] = item
        })
      }
      this.setState({ likedTemplates: dataArr })
    }
  }

  closeDialog = () => {
    this.setState({ isDialogOpened: false });
  };
  onThumbnailClicked = videoId => async event => {
    axios.post(`${GetBaseUrl()}/api/template/inc_views`,
      { template_id: videoId }
    ).then().catch()

    const templates = await this.getTemplateById(videoId)
    this.setState({
      isDialogOpened: true,
      templates,
      selectedVideoId: videoId
    })
  };

  onPageNumberClicked = newPage => event => {
    this.setState({ currentPage: newPage });
  };
  onPreviousPageClicked = newPage => event => {
    this.setState({ currentPage: newPage });
  };
  onNextPageClicked = newPage => event => {
    this.setState({ currentPage: newPage });
  };

  onViewAllFreeVideosButtonClicked = () => {
    const { history } = this.props;
    history.push('/designselect');
  };

  getTemplateById = async (videoId) => {
    return _getTemplateById(videoId, this.state.templates)
  };

  changeSelectedVideo = async newlySelectedVideoId => {
    const templates = await this.getTemplateById(newlySelectedVideoId)
    this.setState({
      templates,
      selectedVideoId: newlySelectedVideoId
    })
  }
  
  replaceTemplateName = name => {
    if (typeof name !== 'string') return null

    name = name.replace(' 16:9', '').replace(' 1:1', '').replace(' 4:5', '').replace(' 9:16', '')
    if (name.includes(' Title') || name.includes(' End')) name = `${name.replace(' Title', '').replace(' End', '')} Title & End`
    
    return name
  }

  render() {
    const {
      history,
      onVideoLikedButtonClicked,
      lang,
    } = this.props;
    let {
      currentPage,
      cardsPerPage,
      likedTemplates: likedVideos,
      templates
    } = this.state;

    if (!Array.isArray(likedVideos)) {
      return <Loading />;
    }
    // if (likedVideos.length === 0) {
    //   return (
    //     <EmptyVideo
    //       onViewAllFreeVideosButtonClicked={
    //         this.onViewAllFreeVideosButtonClicked
    //       }
    //       text1={i18n.t("likedvideo.emptyvideo.text1")}
    //       text2={i18n.t("likedvideo.emptyvideo.text2")}
    //       btn={true}
    //     />
    //   );
    // }

    const cardItems = TemplateHelper.GetRepresentedTemplates(likedVideos, lang)

    return (
      <div className="liked-video-container">
        <div className="title">{i18n.t("likedvideo.componentname")} </div>
        <div className="video-count">{i18n.t("myvideo.text.video1")} {cardItems.length} {i18n.t("myvideo.text.video2")}</div>
        {
          likedVideos.length === 0 ? (
            <EmptyVideo
              onViewAllFreeVideosButtonClicked={
                this.onViewAllFreeVideosButtonClicked
              }
              text1={i18n.t("likedvideo.emptyvideo.text1")}
              text2={i18n.t("likedvideo.emptyvideo.text2")}
              btn={true}
            />
          ) : (
            <div>
              <div className="grid-container">
                {cardItems
                  .slice(
                    currentPage * cardsPerPage,
                    currentPage * cardsPerPage + cardsPerPage
                  )
                  .map(template => (
                    <Card
                      key={template._id}
                      thumbnailUrl={TemplateHelper.getThumbnailImage(template, lang, true) || ""}
                      onThumbnailClicked={this.onThumbnailClicked(template._id)}
                      title={this.replaceTemplateName(TemplateHelper.getName(template, lang))}
                      date={template.date}
                      cardSize={{ width: "140.625px", height: "250px" }}
                    />
                  ))}
              </div>
            </div>
          )
        }
        <DesignSelectPopup
          closeDialog={this.closeDialog}
          isDialogOpened={this.state.isDialogOpened}
          templateGroupMap={this.templateGroupMap}
          selectedVideo={
            templates.filter(
              template => template._id === this.state.selectedVideoId
            )[0]
          }
          onVideoLikedButtonClicked={onVideoLikedButtonClicked}
          history={history}
          changeSelectedVideo={this.changeSelectedVideo}
        />
        <div className="pagination-container">
          <Pagination
            currentPage={currentPage}
            cardsPerPage={cardsPerPage}
            itemCount={likedVideos.length}
            onPageNumberClicked={this.onPageNumberClicked}
            onPreviousPageClicked={this.onPreviousPageClicked}
            onNextPageClicked={this.onNextPageClicked}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  lang: state.langStore.lang
})

export const LikedVideo = connect(mapStateToProps, null)(LikedVideoClass)